import {
    LOAD_CONSULT_SOAT,
    SUCCESS_CONSULT_SOAT,
    ERROR_CONSULT_SOAT,
    SUCCESS_CONSULT_SOAT_PRINT
} from "../types/consultType";

const initialState = {
    isLoading: false,
    fail: false,
    startDate: '',
    endDate: '',
    emissionDate: '',
    urlConstElect: '',
    numDoc: '',
    plateFormat: '',
    plate: '',
    typeDoc: '',
    rutaElectronica: '',
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOAD_CONSULT_SOAT: {
            return {
                ...state,
                isLoading: true,
                fail: false,
            };
        }
        case SUCCESS_CONSULT_SOAT: {
            return {
                ...state,
                isLoading: false,
                fail: false,
                ...action.data,
            };
        }
        case SUCCESS_CONSULT_SOAT_PRINT: {
            return {
                ...state,
                isLoading: false,
                rutaElectronica: action.data
            };
        }
        case ERROR_CONSULT_SOAT: {
            return {
                ...state,
                isLoading: false,
                fail: false,
            };
        }
        default:
            return state;
    }
};